import type { RequestLogEntry, RequestLogType } from './types';

const logStyles = {
  group: 'color: #9C27B0; font-weight: bold; font-size: 14px;',
  request: 'color: #4CAF50; font-weight: bold;',
  response: 'color: #2196F3; font-weight: bold;',
  error: 'color: #F44336; font-weight: bold;',
  info: 'color: #FF9800; font-weight: bold;',
};

export function createRequestLogger(fullUrl: string, requestId: string) {
  const logEntries: RequestLogEntry[] = [];

  const collectLog = (message: string, type: RequestLogType = 'info') => {
    logEntries.push({ message, type });
  };

  const printLogs = () => {
    console.group(`%c🌐 API 요청 [${requestId}] ${fullUrl}`, logStyles.group);
    logEntries.forEach(entry => {
      const emoji = {
        request: '🚀',
        response: '📩',
        error: '❌',
        info: 'ℹ️',
      }[entry.type];

      let messageObject;
      try {
        messageObject = JSON.parse(entry.message);
      } catch (error) {
        messageObject = entry.message;
      }

      console.log(
        `%c${emoji} ${entry.type}:`,
        logStyles[entry.type],
        messageObject
      );
    });
    console.groupEnd();
  };

  return { collectLog, printLogs };
}
